import { render } from "./App.vue?vue&type=template&id=c3dc2fac"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c3dc2fac&lang=scss"
script.render = render

export default script